import React, { useState, useEffect } from "react";
import { Table, Button, Spinner, Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import getCsrfToken from "../../clients/features/get_csrfToken";

const PendingCancellationsTable = () => {
  const [loading, setLoading] = useState(true);
  const [reservations, setReservations] = useState([]);
  const [error, setError] = useState(null);

  const hotelParams = useParams();
  const hotelId = hotelParams.hotelId;

  useEffect(() => {
    const fetchReservations = async () => {
      try {
        setLoading(true);
        const { data } = await axios({
          method: "get",
          url: `https://api.komorotel.com/api/reservation/${hotelId}/pending-cancellations`,
          withCredentials: true,
        });
        setReservations(data);
      } catch (err) {
        setError(err.message || "Une erreur est survenue");
      } finally {
        setLoading(false);
      }
    };

    fetchReservations();
  }, [hotelId]);

  const calculateNights = (checkInDate, checkOutDate) => {
    const startDate = new Date(checkInDate);
    const endDate = new Date(checkOutDate);
    return Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
  };

  const handleCancelReservation = async (reservationId) => {
    const csrfToken = await getCsrfToken(); // Récupérer le token CSRF

    try {
      setLoading(true);
      await axios({
        method: "put",
        url: `https://api.komorotel.com/api/reservation/cancellation-requests/${reservationId}`,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'CSRF-Token': csrfToken // Ajouter le token CSRF
        },
        data:{
            status: 'approved'
        }
      });
      alert("La réservation a bien été annulé !")
      // Mise à jour des réservations après annulation
      setReservations((prevReservations) =>
        prevReservations.filter((res) => res._id !== reservationId)
      );
    } catch (err) {
      console.error("Erreur lors de l'annulation :", err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Row className="mb-4">
        <Col>
          <h1 className="mt-4 mb-4">Annulations en Attente</h1>
        </Col>
      </Row>

      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : error ? (
        <div className="text-danger text-center">{error}</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <Table striped bordered hover responsive style={{ tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Date</th>
                <th>Nombre de nuitées</th>
                <th>Type #</th>
                <th>Prix Total</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {reservations.map((reservation) => (
                <tr key={reservation._id}>
                  <td>{reservation.guestId?.surname || "N/A"}</td>
                  <td>{reservation.guestId?.name || "N/A"}</td>
                  <td>{new Date(reservation.createdAt).toLocaleDateString("fr-FR")}</td>
                  <td>
                    {calculateNights(
                      reservation.reservationId?.checkInDate,
                      reservation.reservationId?.checkOutDate
                    )}
                  </td>
                  <td>{reservation.reservationId?.roomId?.title || "N/A"}</td>
                  <td>{reservation.reservationId?.totalPrice || "N/A"} €</td>
                  <td>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleCancelReservation(reservation._id)}
                    >
                      Annuler la réservation
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Container>
  );
};

export default PendingCancellationsTable;
